import { defineMessages } from 'react-intl';

export const a2aPermissionMessages = defineMessages({
  sectionTitle: {
    id: 'oauth.a2a.permission.sectionTitle',
    defaultMessage: 'Permissions',
    description: 'Section heading for A2A permissions',
  },
  rovoChatTitle: {
    id: 'oauth.a2a.permission.rovoChatTitle',
    defaultMessage: 'Rovo Chat',
    description: 'Title for the Rovo Chat permission',
  },
  rovoChatDescription: {
    id: 'oauth.a2a.permission.rovoChatDescription',
    defaultMessage:
      'Chat with Rovo and agents to search, create, and manage work across your Atlassian apps (Jira, Confluence, etc.) and other connected apps on your behalf.',
    description: 'Description for the Rovo Chat permission',
  },
});
